import React, { useEffect, useState } from "react";
import { getAdminConsultationMode } from "../../utils/consultationMode";
import Pagination from "react-js-pagination";
import NotFound from "../../components/not-found/NotFound";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { Link, useSearchParams } from "react-router-dom";
import IconButton from "../../components/Button/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BlockIcon from "@mui/icons-material/Block";
import Switch from "../../components/Switch/Switch";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { DatePicker, Select } from "../../components/Form";
import { toast } from "sonner";
import useDebounce from "../../hooks/useDebounce";
// import { getOrderApi } from '../../services/orderManagement'
// import { SiMicrosoftexcel } from "react-icons/si";
import { IoSearch } from "react-icons/io5";
import profileImage from "../../Assests/image/profile_not_found.png";
import { user } from "../../routes/route";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import {
    FailedConsulatationApi,
    getUserHistoryApi,
    getUserListApi,
    logoutUserFromAllDevice,
    Missed_callAPi,
    sendOtpAPi,
    waitlistApi,
    //   verifyOtpApi,
} from "../../services/userManagement";
import findSerialNumber from "../../utils/findSerialNumber";

import { toastMessage } from '../../utils/toastMessage'
import { fatchCategoryApi } from '../../services/categoryManagement'
import { charLimit } from '../../utils/charLimit'
import common from '../../routes/common'
import UserStatus from "../userManagement/UserStatus";
import { dateFormat, dateFormatUtc } from '../../utils/dateFormat'
import { ConsultationCount, gender } from '../../utils/genderList'
import scrollToUp from '../../utils/scrollToUp'
import { CapitalizeFirstWord } from '../../utils/CapitalizeFirstWord'
import Loader from '../../comman/Loader'
import useDownloadWithPassword from '../../hooks/useDownloadWithPassword'
import csv from '../../Assests/image/csv.svg'
import useButtonLoader from '../../hooks/UseButtonLoader'
import ModalBox from '../../components/modal/ModalBox'
import { useOTPModalCNF } from '../../hooks/useOTPModalCNF'
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, TextField, Typography } from "@mui/material";
import constants from "../../utils/constants";
import ConsultationCustomerTabs from "../../components/PowerCustomer/ConsultationCustomerTabs";
import SectionLoaderOverlay from "../../components/loader/SectionLoaderOverlay";

const { USER_DETAIL, USER_DELETE } = user;
const { NOT_FOUND } = common;

// Utility function to calculate age from date of birth
const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return "---";
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    if(age < 0) {
        return "---";
    }
    
    return age;
};

// console.log('Gender', gender)

const MissedCall = () => {
    let URL = constants.SERVER_API
    const [searchParam, setSearchParam] = useSearchParams()
    let activePage = +searchParam.get('page') || 1
    const { open: openCNFModal, OTPModalCNF } = useOTPModalCNF();
    const [search, setSearch] = useState(
        getLocalStorage("userList", "search") || ""
    );
    const debounceValue = useDebounce(search || "", 300);
    const [total, setTotal] = useState(0);
    const [userList, setUserList] = useState([]);
    const [problemList, setProblemList] = useState([]);
    const [statusModal, setStatusModal] = useState(false);
    const [statusValue, setStatusValue] = useState("");
    const [statusId, setStatusId] = useState("");
    const [logoutUserModel, setLogoutUserModel] = useState(false);

    const [buttonref, buttonLoader] = useButtonLoader("Logout");

    const [WriteOtpModal, setwriteOtpModal] = useState(false);
    const [pageLimit, setPageLimit] = useState(10); 

    const handlePageLimitChange = (event) => {
        setPageLimit(event.target.value);
        // setActivePage(1);
    };
    
    // Filter states
    const [timeRange, setTimeRange] = useState(searchParam.get("timeRange") || "");
    const [timeRangeStartDate, setTimeRangeStartDate] = useState(searchParam.get("timeRangeStartDate") || "");
    const [timeRangeEndDate, setTimeRangeEndDate] = useState(searchParam.get("timeRangeEndDate") || "");
    const [consultationMode, setConsultationMode] = useState(searchParam.get("consultationMode") || "");
    const [consultationType, setConsultationType] = useState(searchParam.get("consultationType") || "");
    const [missedBy, setMissedBy] = useState(searchParam.get("missedBy") || "");
    const [uniqueUser, setUniqueUser] = useState(searchParam.get("uniqueUser") || "");
    const customerType = searchParam.get("customerType") || "normal";
    
    // Time range options
    const timeRangeOptions = [
        { value: "today", label: "Today" },
        { value: "yesterday", label: "Yesterday" },
        { value: "last7days", label: "Last 7 Days" },
        { value: "last30days", label: "Last 30 Days" },
        { value: "thisMonth", label: "This Month" },
        { value: "lastMonth", label: "Last Month" },
        { value: "custom", label: "Custom Range" }
    ];

    const genderValue = searchParam.get("gender") || "";
    const consultationCountValue = searchParam.get("ConsultationCount") || "";
    // const [statusSearch, setStatusSearch] = useState('')
    const registrationDate = searchParam.get("registrationDate") || "";
    const problemValue = searchParam.get("problem") || "";
    // const [endDateSearch, setEndDateSearch] = useState('')

    useEffect(() => {
        setLocalStorage("userList", "search", search);
    }, [search]);

    const handleLogoutHandler = async () => {
        try {
            buttonLoader(true);
            const sendData = { userId: statusId };
            const { data } = await logoutUserFromAllDevice(sendData);
            if (data.code === 200) {
                console.log("Date", data);
                logoutCloseModel();
            } else {
                toastMessage(data.message, "error", "userList");
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            buttonLoader(false);
        }
    };

    // handle all hooks
    const { loading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();
    const [isPageLoading, setIsPageLoading] = useState(false);

    const handleExcelDownload = () => {
        try {
            const url = `${URL}/admin/user/download/missed`;
            const params = {
                filter: { customerType }
            };
            
            // Add all current filters to the export
            if(search) {
                params.search = search;
            }
            if (timeRange) {
                params.filter.timeRange = timeRange;
            }
            if (timeRangeStartDate) {
                params.filter.timeRangeStartDate = timeRangeStartDate;
            }
            if (timeRangeEndDate) {
                params.filter.timeRangeEndDate = timeRangeEndDate;
            }
            if (consultationMode) {
                params.filter.consultationMode = consultationMode;
            }
            if (consultationType) {
                params.filter.consultationType = consultationType;
            }
            if (missedBy) {
                params.filter.missedBy = missedBy;
            }
            if (uniqueUser) {
                params.filter.uniqueUser = uniqueUser;
            }
            
            requestDownload(url, `missed-calls-chats-${dateFormat(new Date())}.csv`, params);
        } catch (e) {
            console.log(e.message);
        }
    };
    //*********Handel status********* */
    const statusUpdateHandler = (id, status) => {
        setStatusModal(true);
        setStatusId(id);
        setStatusValue(status);
    };

    //*********Logout handler function********* */
    const userLogoutHandler = (id) => {
        setStatusId(id);
        setLogoutUserModel(true);
    };

    // gender handler

    const genderHandler = (value) => {
        if (genderValue === value) {
            searchParam.delete("gender");
        } else {
            searchParam.set("gender", value);
        }
        searchParam.delete("page");
        setSearchParam(searchParam);
    };
    // Problem handler

    const problemValueHandler = (value) => {
        if (problemValue === value) {
            searchParam.delete("problem");
        } else {
            searchParam.set("problem", value);
        }
        searchParam.delete("page");
        setSearchParam(searchParam);
    };
    // consultation count handler

    const TotalconsultationHandler = (value) => {
        if (consultationCountValue === value) {
            searchParam.delete("ConsultationCount");
        } else {
            searchParam.set("ConsultationCount", value);
        }
        searchParam.delete("page");
        setSearchParam(searchParam);
    };

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        searchParam.set("page", event);
        setSearchParam(searchParam);
    };
    //*********Handel refresh icon********* */
    const refreshHandler = (event) => {
        setSearch("");
        setTimeRange("");
        setTimeRangeStartDate("");
        setTimeRangeEndDate("");
        setConsultationMode("");
        setConsultationType("");
        setMissedBy("");
        setUniqueUser("");
        setPageLimit(10);
        searchParam.delete("page");
        searchParam.delete("gender");
        searchParam.delete("problem");
        searchParam.delete("registrationDate");
        searchParam.delete("ConsultationCount");
        searchParam.delete("timeRange");
        searchParam.delete("timeRangeStartDate");
        searchParam.delete("timeRangeEndDate");
        searchParam.delete("consultationMode");
        searchParam.delete("consultationType");
        searchParam.delete("missedBy");
        searchParam.delete("uniqueUser");
        setSearchParam(searchParam);
    };

    // Time range handler
    const handleTimeRangeChange = (value) => {
        setTimeRange(value);
        if (value !== 'custom') {
            setTimeRangeStartDate("");
            setTimeRangeEndDate("");
        }
    };

    // Time range date change handler
    const handleTimeRangeDateChange = (type, value) => {
        if (type === 'start') {
            setTimeRangeStartDate(value);
        } else {
            setTimeRangeEndDate(value);
        }
    };

    // Apply filter function
    const applyFilter = () => {
        searchParam.set("page", "1");
        setSearchParam(searchParam);
    };

    //------------------usre-listing-Api----------------------------------
    const getUserList = async (debounceValue) => {
        try {
            setIsPageLoading(true);
            const sendData = {
                page: `${activePage}`,
                limit: `${pageLimit}`,
                filter: { customerType }
            };

            if (search) {
                sendData.search = search;
            }
            if (timeRange) {
                sendData.filter.timeRange = timeRange;
            }
            if (timeRangeStartDate) {
                sendData.filter.timeRangeStartDate = timeRangeStartDate;
            }
            if (timeRangeEndDate) {
                sendData.filter.timeRangeEndDate = timeRangeEndDate;
            }
            if (consultationMode) {
                sendData.filter.consultationMode = consultationMode;
            }
            if (consultationType) {
                sendData.filter.consultationType = consultationType;
            }
            if (missedBy) {
                sendData.filter.missedBy = missedBy;
            }
            if (uniqueUser) {
                sendData.filter.uniqueUser = uniqueUser;
            }

            // if (debounceValue) {
            //     sendData.page = String(activePage)
            //     sendData.search = debounceValue
            //     // searchParam.delete('page')
            //     setSearchParam(searchParam)
            // }
            // if (problemValue) {
            //     sendData.filter.problems = problemValue;
            // }
            // if (genderValue) {
            //     sendData.filter.gender = genderValue;
            // }
            // if (registrationDate) {
            //     sendData.filter.registerDate = registrationDate;
            // }
            // if (consultationCountValue) {
            //     sendData.consultationCountFilter = consultationCountValue;
            // }

            const { data } = await Missed_callAPi(sendData);
            if (data.code === 200) {
                console.log('data ===>', data.result.list)
                console.log("remainingCoins ===>");
                data.result.list.map((user, index) => {
                    console.log(`User ${index + 1}:`, user.remainingCoins);
                });
                setUserList(data?.result?.list || []);
                setTotal(data?.result?.total || 0);
                // scrollToUp();
            } else {
                setUserList([]);
                setTotal(0);
                toastMessage(data.message, "error", "userList");
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsPageLoading(false);
        }
    };

    const closeModel = () => {
        setStatusModal(false);
        setStatusValue("");
        setStatusId("");
    };

    const logoutCloseModel = () => {
        setLogoutUserModel(false);
        setStatusId("");
    };

    // problem list handler function

    const fetchProblemHandler = async () => {
        try {
            const { data } = await fatchCategoryApi();
            if (data.code === 200) {
                setProblemList(data?.result?.categoryList || []);
            } else {
                setProblemList([]);
                toastMessage(data.message, "error", "categoryList");
            }
        } catch (error) {
            console.log("error", error);
        }
    };



    const handleRegistrationDate = (date) => {
        const utcDateString = dateFormatUtc(date);
        searchParam.delete("page");
        searchParam.set("registrationDate", utcDateString);
        setSearchParam(searchParam);
    };

    // useEffect(() => {
    //   if (debounceValue) {
    //     searchParam.set('query', debounceValue)
    //   } else {
    //     searchParam.delete('query')
    //   }
    //   if (activePage === 1) {
    //     searchParam.delete('page')
    //   }
    //   setSearchParam(searchParam)
    //   getOrder(activePage, debounceValue)
    // }, [searchParam, debounceValue])

    useEffect(() => {
        if (Number(activePage) === 1) {
            searchParam.delete("page");
        }
        if (!genderValue) {
            searchParam.delete("gender");
        }
        if (!problemValue) {
            searchParam.delete("problem");
        }
        setSearchParam(searchParam);
        getUserList(debounceValue);
    }, [searchParam, debounceValue, pageLimit]);

    useEffect(() => {
        fetchProblemHandler();
    }, []);
    return (
        <>
            <OTPModalCNF verifiedHandle={() => {
                console.log('OTP Verified Successfully!')
            }} />
            <div className="WrapperArea">
                <div className="WrapperBox">
                    <div className="TitleBox">
                        {/* <div className="user_management_heading"> */}
                        <h4 className="Title">Missed Call/Chat</h4>
                        <div className="block_user_button">
                            <SecondaryButton 
                                onClick={handleExcelDownload}
                                disabled={loading}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '8px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                {loading ? (
                                    <Loader />
                                ) : (
                                    <>
                                        <div className="csv-image-wrapper" style={{ width: '16px', height: '16px' }}>
                                            <img src={csv} alt="csv file download" style={{ width: '100%', height: '100%' }} />
                                        </div>
                                        Export CSV
                                    </>
                                )}
                            </SecondaryButton>
                            {/* <div className="mx-2">
                <Link to={`${USER_DELETE}`}>
                  <div className="block_user_button">
                    <button
                    // onClick={() => setAddConsultantModel(true)}
                    >
                      {/* <AddIcon /> */}
                            {/* Deleted User
                    </button>
                  </div>
                </Link>
              </div>  */}
                        </div>
                        {/* </div> */}
                    </div>
                    <ConsultationCustomerTabs value={customerType} onChange={(value) => {
                        searchParam.set("customerType", value);
                        searchParam.delete("page");
                        setSearchParam(searchParam);
                    }} />
                    <div className="FilterBox FilterArea" style={{ flexDirection: 'column' }}>
                        {/* Row 1: Search Bar and Basic Filters */}
                        <div className="group_filter_value" style={{ 
                            marginBottom: '15px', 
                            display: 'flex !important', 
                            flexWrap: 'wrap !important', 
                            gap: '15px', 
                            alignItems: 'center',
                            width: '100%',
                            flexDirection: 'row'
                        }}>
                            {/* Search Bar */}
                            <div className="form-group search_md_size userSearch" style={{ minWidth: '200px', flex: '1 1 auto' }}>
                                <input
                                    type="search"
                                    className={`form-control ${search && "active"}`}
                                    placeholder="Search"
                                    value={search || ""}
                                    style={{ "--color": "#FF8989" }}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                {/* <span className="user_search_icon">
                                    <IoSearch />
                                </span> */}
                            </div>

                            {/* Mode of Consultation */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <Select
                                    className={`form-control ${consultationMode && "active"}`}
                                    value={consultationMode}
                                    onChange={(e) => setConsultationMode(e.target.value)}
                                >
                                    <option value="">Mode of Consultation</option>
                                    <option value="call">Call</option>
                                    <option value="chat">Chat</option>
                                    <option value="video">Video</option>
                                </Select>
                            </div>

                            {/* Type of Consultation */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <Select
                                    className={`form-control ${consultationType && "active"}`}
                                    value={consultationType}
                                    onChange={(e) => setConsultationType(e.target.value)}
                                >
                                    <option value="">Type of Consultation</option>
                                    <option value="free">Free</option>
                                    <option value="paid">Paid</option>
                                </Select>
                            </div>

                            {/* Missed By */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <Select
                                    className={`form-control ${missedBy && "active"}`}
                                    value={missedBy}
                                    onChange={(e) => setMissedBy(e.target.value)}
                                >
                                    <option value="">Missed By</option>
                                    <option value="user">User</option>
                                    <option value="consultant">Consultant</option>
                                    <option value="both">Both</option>
                                    <option value="system">System</option>
                                </Select>
                            </div>

                            {/* Unique User */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <Select
                                    className={`form-control ${uniqueUser && "active"}`}
                                    value={uniqueUser}
                                    onChange={(e) => setUniqueUser(e.target.value)}
                                >
                                    <option value="">Unique User</option>
                                    <option value="true">Show Unique Users</option>
                                    <option value="false">Show All Entries</option>
                                </Select>
                            </div>
                      
                            {/* Time Range Filter */}
                            <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <InputLabel>Time Range</InputLabel>
                                    <MuiSelect
                                        value={timeRange}
                                        onChange={(e) => handleTimeRangeChange(e.target.value)}
                                        label="Time Range"
                                    >
                                        <MenuItem value="">
                                            <em>All Time Ranges</em>
                                        </MenuItem>
                                        {timeRangeOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </MuiSelect>
                                </FormControl>
                            </div>
                            
                            {timeRange === 'custom' && (
                                <>
                                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                        <TextField
                                            size="small"
                                            type="date"
                                            variant="outlined"
                                            label="Start Date"
                                            value={timeRangeStartDate}
                                            onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                    <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                                        <TextField
                                            size="small"
                                            type="date"
                                            variant="outlined"
                                            label="End Date"
                                            value={timeRangeEndDate}
                                            onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </div>
                                </>
                            )}

                            {/* Apply Filter & Refresh */}
                            <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                                <SecondaryButton onClick={applyFilter}>
                                    Apply
                                </SecondaryButton>
                                <SecondaryButton onClick={refreshHandler}>
                                    Clear
                                </SecondaryButton>
                            </div>
                        </div>
                    </div>
                    <div className="content-table" style={{ position: "relative", minHeight: 200 }}>
                        {isPageLoading && <SectionLoaderOverlay />}
                            <table>
                                <thead>
                                    <tr>
                                        <th>S. No.</th>
                                        <th>Missed Date & Time</th>
                                        <th>Mode of Consultation</th>
                                        <th>Type of Consultation</th>
                                        <th>Missed by</th>
                                        <th>User Name</th>
                                        <th>User Mobile</th>
                                        <th>User Gender</th>
                                        <th>Problem</th>
                                        <th>Consultant Name</th>
                                        <th>Consultant Mobile</th>
                                        {/* <th>Registration Date</th> */}
                                        <th>User Date of Birth</th>
                                        <th>User Age</th>
                                        <th>Customer Type</th>
                                        <th>Power Origin</th>
                                        <th>Power Customer Since</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userList.length > 0 ? (
                                        userList.map((user, index) => {
                                            console.log("user ===>", user)
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{findSerialNumber(index, activePage, 10)}</td>
                                                        <td>
                                                            {
                                                                user.logs?.find(log => log.callBy === "user")
                                                                    ? dateFormat(new Date(user.logs.find(log => log.callBy === "user").timestamp))
                                                                    : dateFormat(user.createdAt) || "---"
                                                            }
                                                        </td>
                                                        <td>{getAdminConsultationMode(user)}</td>
                                                        <td>{user?.coupon?.code === "FREE5MINUTES" ? "Free" : "Paid"}</td>
                                                        <td>
                                                            {
                                                                (() => {
                                                                    const missedLog = user.logs?.find(log => log.callStatus === "missed");

                                                                    if (!missedLog) return "---";

                                                                    if (missedLog.actionBy === user.user_id) return "Missed by User";
                                                                    if (missedLog.actionBy === user.consultant_id) return "Missed by Consultant";
                                                                    if (missedLog.actionBy === "both") return "Missed by Both";
                                                                    if (missedLog.actionBy === "system") return "System Missed";

                                                                    return "Unknown";
                                                                })()
                                                            }
                                                        </td>
                                                        <td><Link to={`${USER_DETAIL}/${user.user_id}`} target="_blank">{user?.request_form?.firstName || "---"}</Link></td>
                                                        <td>{user?.userDetails?.mobile || "---"}</td>
                                                        <td>
                                                            {user.request_form?.gender
                                                                ? CapitalizeFirstWord(user.request_form?.gender)
                                                                : "---"}
                                                        </td>
                                                        <td>{user?.request_form?.concern || "---"}</td>
                                                        <td><Link target="_blank" to={`/consultant-management/consultant-detail/${user.consultant_id}`}>{user?.consultantDetails?.accountName || "---"}</Link></td>
                                                        <td>{user?.consultantDetails?.mobile || "---"}</td>
                                                        {/* <td>{dateFormat(user.createdAt) || "---"}</td> */}
                                                        <td>{user.request_form?.dateOfBirth || "---"}</td>
                                                        <td>{calculateAge(user.request_form?.dateOfBirth)}</td>
                                                        <td>{user?.customerType || "---"}</td>
                                                        <td>{user?.powerOrigin || "---"}</td>
                                                        <td>{user?.powerCustomerSince ? dateFormat(user.powerCustomerSince) : "---"}</td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <NotFound
                                            cols={16}
                                            msg="User not found!"
                                            icon={NOT_FOUND}
                                            loader={null}
                                        />
                                    )}
                                </tbody>
                            </table>
                    </div>
                    <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <Typography variant="body2" color="textSecondary">
                                Show:
                            </Typography>
                            <select
                                value={pageLimit}
                                onChange={(e) => handlePageLimitChange(e)}
                                style={{ 
                                    padding: '8px 12px', 
                                    border: '1px solid #ccc', 
                                    borderRadius: '4px',
                                    fontSize: '14px',
                                    minWidth: '80px'
                                }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <Typography variant="body2" color="textSecondary">
                                 per page
                            </Typography>
                        </div>
                        
                        <div className="d-flex align-items-center gap-2">
                            <Typography variant="body2" color="textSecondary">
                                Showing {((activePage - 1) * pageLimit) + 1} to {Math.min(activePage * pageLimit, total)} of {total} items
                            </Typography>
                        </div>
                        
                        {total > pageLimit && (
                             <div className="pagination-wrapper">
                             <div className="Pagination">
                                 <Pagination
                                     activePage={activePage}
                                     previousLabel={"previous"}
                                     nextLabel={"next"}
                                     itemsCountPerPage={10}
                                     totalItemsCount={total}
                                     pageRangeDisplayed={5}
                                     onChange={handlePageChange}
                                     hideDisabled={true}
                                 />
                             </div>
                         </div>
                        )}
                    </div>
                 
                </div>
            </div>
            {statusModal && (
                <UserStatus
                    show={statusModal}
                    close={closeModel}
                    setListing={setUserList}
                    setUserDetail={""}
                    status={statusValue}
                    id={statusId}
                />
            )}

            {logoutUserModel && (
                <ModalBox
                    status={logoutUserModel}
                    onClose={logoutCloseModel}
                    title="Logout User from all Device"
                    description="Do you want to logout the user from all the devices?"
                    action={handleLogoutHandler}
                    ref={buttonref}
                />
            )}

            <DownloadPasswordModal />
        </>
    );
};

export default MissedCall;
